import Item from "./item"
import classNames from "classnames"

export default function Menu({
  menuClasses,
  items,
  location,
  caret = false,
  hover = false,
  handleOverlay,
  ariaLabelledby
}) {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <ul
      className={classNames([menuClasses, { "has-caret": caret }])}
      role="menu"
      aria-labelledby={ariaLabelledby}
      data-location={location + "-menu"}
      onMouseEnter={() => hover && handleOverlay(location, true)}
      onMouseLeave={() => hover && handleOverlay(location, false)}>
      {items.map((item, index) => (
        <Item
          caret={caret}
          hover={hover}
          key={location + item.url + index}
          location={location}
          item={item}
        />
      ))}
    </ul>
  )
}
